import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import { getLanguage } from 'util/hooks/useLanguage';
import { getWhiteLabelTranslation } from 'util/stringUtils';

import en from './locales/en/translation.json';
import pt from './locales/pt/translation.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    pt: { translation: pt },
  },
  lng: getLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

i18n.services.formatter?.add('customFormat', (value) => {
  // Modify the translation string here
  return getWhiteLabelTranslation(value); // Example: make everything uppercase
});

export default i18n;
